import { Button } from "@components/button";
import { EllipsisText } from "@components/ellipsis-text";
import { Modal } from "@components/modal";
import { RowTable } from "@components/row-table";
import { Config, DoubleText } from "@components/table";
import {
  PaymentCredited,
  PaymentNotCredited,
  PaymentProcessing,
} from "@features/appeals/components/status";
import {
  MerchantOrder,
  MerchantOrderStatus,
  MerchantOrderType,
} from "@features/merchantOrder/api";
import { formatDate, formatTime } from "@helpers/date";
import { formatRubles, formatUsdt } from "@helpers/format";

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  data: MerchantOrder;
  setAppealStatus: () => void;
};

export const OrderModal = ({
  hideModal,
  isModalOpen,
  data,
  setAppealStatus,
}: Props) => {
  const onBtnClick = () => {
    setAppealStatus();
    hideModal();
  };
  const config: Config<MerchantOrder> = [
    {
      source: "id",
      label: "Номер заявки",
      renderComponent: (data) => <EllipsisText text={data} copy />,
    },
    {
      source: "invid",
      label: "Invid заявки",
      renderComponent: (data) => <EllipsisText text={data} copy />,
    },
    { source: "cache", label: "Касса" },
    {
      source: "created_at",
      label: "Дата",
      renderComponent: (data) => (
        <DoubleText
          text={formatTime(new Date(data))}
          subText={formatDate(new Date(data))}
        />
      ),
    },
    {
      label: "Сумма заявки",
      source: "order_start_amount",
      renderComponent: (cellData, item) => {
        const usdt = formatUsdt(item.order_start_amount_usdt);
        const rubles = formatRubles(cellData);
        return <DoubleText text={rubles} subText={usdt} />;
      },
    },
    {
      label: "Измененная сумма",
      source: "merchant_amount",
      renderComponent: (data, item) => {
        if (item.merchant_amount_usdt == null || data == null) return "";
        if (item.merchant_amount_usdt == 0 || data == 0) return "";
        const usdt = formatUsdt(item.merchant_amount_usdt);
        const rubles = formatRubles(data);

        return <DoubleText subText={usdt} text={rubles} />;
      },
    },
    {
      label: "Итоговая сумма",
      source: "order_final_amount",
      renderComponent: (cellData, item) => {
        const usdt = formatUsdt(item.order_final_amount_usdt);
        const rubles = formatRubles(cellData);
        return <DoubleText text={rubles} subText={usdt} />;
      },
    },
    {
      source: "exchange_rate",
      label: "Курс",
      renderComponent: (data) => <>{formatUsdt(data, true)}</>,
    },
    {
      source: "ern_usdt",
      label: "Доход/Списание",
      renderComponent: (data, item) => (
        <strong
          style={{
            color: item.type == MerchantOrderType.PayOut ? "red" : "green",
          }}
        >
          {formatUsdt(data)}
        </strong>
      ),
    },
    { source: "method", label: "Метод" },
    // { source: "invid", label: "Номер заявки" },
  ];
  return (
    <Modal
      title={`Заявка №${data.invid}`}
      isOpen={isModalOpen}
      onClose={hideModal}
    >
      {data.status === MerchantOrderStatus.Completed && <PaymentCredited />}
      {data.status === MerchantOrderStatus.Canceled && <PaymentNotCredited />}
      {data.status === MerchantOrderStatus.Pending && (
        <PaymentProcessing text="В процессе" />
      )}
      {data.status === MerchantOrderStatus.DisputeOpen && (
        <PaymentProcessing text="Спор открыт" />
      )}
      <RowTable config={config} data={data} />
      {(data.status == MerchantOrderStatus.Completed ||
        data.status == MerchantOrderStatus.Canceled) &&
      data.appeal == null ? (
        <Button onClick={onBtnClick}>Создать апелляцию</Button>
      ) : data.appeal != null ? (
        <Button onClick={onBtnClick}>Посмотреть аппеляцию</Button>
      ) : null}
    </Modal>
  );
};
